
module.service('StudentExportService', StudentExportService);

// @ngInject
function StudentExportService($http, $analytics, ApiUrl, FileService) {
    var url = ApiUrl.partial('export');

    this.getAvailableExports = getAvailableExports;
    this.getSummary = getSummary;
    this.downloadFile = downloadFile;

    function fileUrl(programId, exportName) {
        return url(programId, exportName, 'excel.xlsx');
    }

    function getAvailableExports(programId) {
        return $http.get(url(programId))
            .then(function(response) { return response.data.items })
    }

    function getSummary(programId, exportName, tags) {
        var params = {params: tags || {}};
        return $http.get(url(programId, exportName), params)
            .then(function(response) {return response.data });
    }

    function downloadFile(programId, exportName, tags) {
        var url = fileUrl(programId, exportName);
        $analytics.eventTrack('export', {label: exportName});
        return FileService.downloadFile(url, tags);
    }
}
